import apiClient from '@/lib/api/apiClient'
import { extractErrorMessage } from '@/lib/utils/errorHandling'
import type {
  PolicyByCategory,
  Role,
  RoleListParams,
  RoleListResponse,
  RoleSubmitPayload,
  TileSummary,
} from '../types'
import { asStringIdArray } from '../utils/asStringIdArray'

export async function getRoles(params: RoleListParams = {}): Promise<Role[]> {
  try {
    const response = await apiClient.get<RoleListResponse>('/api/user_roles', { params })
    return response.data?.data ?? []
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to load roles')
  }
}

export async function getRole(roleKey: string): Promise<Role> {
  try {
    const response = await apiClient.get<Role>(
      `/api/user_roles/${encodeURIComponent(roleKey)}`,
    )
    const role = response.data
    return {
      ...role,
      tiles: asStringIdArray(role?.tiles),
      policy: asStringIdArray(role?.policy),
    }
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to load role')
  }
}

export async function saveRole(
  roleKey: string,
  payload: RoleSubmitPayload,
): Promise<Role> {
  try {
    const response = await apiClient.post<Role>(
      `/api/user_roles/${encodeURIComponent(roleKey)}`,
      payload,
    )
    return response.data
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to save role')
  }
}

export async function getAllTiles(): Promise<TileSummary[]> {
  try {
    const response = await apiClient.get<TileSummary[]>('/api/dashboard_tiles')
    return response.data ?? []
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to load dashboard tiles')
  }
}

export async function getAllPolicy(): Promise<PolicyByCategory> {
  try {
    const response = await apiClient.get<PolicyByCategory>('/api/all_policy')
    return response.data ?? {}
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to load policies')
  }
}
